import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
 

function Website() {
  const [copied, setCopied] = React.useState(false);
  const [isTrueVal, setIsTrueVal] = React.useState(false);
  const [inputFieldsJp, setInputFieldsJp] = useState({
      type: "WebSite",
      name: '',
      url:'',
      internalSearch:'', 
      externalSearch:'',
  })
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };
  const handleChange5 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if(name === 'url'){
      let isTrueValss = !value || urlPatternValidation(value);
      if(isTrueValss === false)
      {
        setIsTrueVal(true);
      }
      else{
        setIsTrueVal(false);
      }
    }
    setInputFieldsJp((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
  }
  
  function MyButton(props) {
    return <button {...props} />
  }
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, []) 
  const JpIsMyCopy = 
    `<script type="application/ld+json">
    {
      "@context": "https://schema.org/", 
      "@type": "WebSite", 
      "name": "`+inputFieldsJp.name+`",
      "url": "`+inputFieldsJp.url+`",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "`+inputFieldsJp.internalSearch+`{search_term_string}`+inputFieldsJp.externalSearch+`",
        "query-input": "required name=search_term_string"
      }
    }
    </script>`;
    const resetFun = () =>{
      const sws_rows = {
        type: "WebSite",
        name: '',
        url:'',
        internalSearch:'', 
        externalSearch:'',
    };
    setInputFieldsJp(sws_rows);  
      
    }
    return (
        <div className='row mt-5 website_row'>
          <div className='col-md-8 ps-0 mb-5 border'>
            <div className='mt-2 mb-2  article_title'><i className="fa-solid fa-globe me-2"></i> <b>Website - Sitelinks Searchbox</b> </div>
              <div className="row input_fields d-flex">
                <div className="col-md-12">
                  <div className="form-group me-2 mb-2">
                    <label>Name</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.name} name="name" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group me-2 mb-2">
                  <label>URL</label>
                    <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.url} name="url" className="form-control"/>
                  </div>
                  {isTrueVal && (
                    <div style={{ color: "#F61C04" }}>URL is not valid.</div>
                  )}
                </div>
                <div className="col-md-12">
                  <div className="form-group me-2 mb-2">
                  <label>internalSearch</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.internalSearch} name="internalSearch" className="form-control" />
                  </div>
                </div>
                 
                <div className="col-md-12">
                <label>externalSearch</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.externalSearch} name="externalSearch" className="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          <div className='col-md-4'>
           <div className="card">
             <div className="card-header d-flex">
               <CopyToClipboard onCopy={onCopy} text={JpIsMyCopy} >
                 <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
               </CopyToClipboard>
                
                 <MyButton className="btn btn-success" onClick={()=> resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton> 
             </div>
             <div className="card-body">
               {JpIsMyCopy}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
  );
}

export default Website